import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { FeedActionButton } from '../common/FeedActionButton';

/** The follow-up's way on, and 标记已读 beside it while it is unread. */
export const FollowupActions = memo(
  ({
    primary,
    onMarkRead,
  }: {
    primary: { title: string; onPress: () => void } | null;
    /** Null: already read, or this host cannot mark it. */
    onMarkRead: (() => void) | null;
  }) => {
    const { rpx } = useResponsiveContext();
    if (!primary && !onMarkRead) return null;
    return (
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: rpx(8),
          marginTop: rpx(12),
        }}
      >
        {primary ? (
          <FeedActionButton title={primary.title} onPress={primary.onPress} />
        ) : null}
        {onMarkRead ? (
          <FeedActionButton
            title="标记已读"
            tone="secondary"
            onPress={onMarkRead}
          />
        ) : null}
      </View>
    );
  },
);
